export enum HearAboutUs {
  GoogleSearch = 1,
  Facebook = 2,
  Indeed = 3,
  Instagram = 4,
  LinkedIn = 5,
  Seek = 6,
  UniOpenDay = 7,
  SchoolDailyOrganiser = 8,
  FriendOrColleague = 9,
  Other = 10,
}
